import React, { SFC } from 'react';
import classNames from 'classnames';

import styles from './inbound.module.styl';
import { getTranslator, I18n } from '../../../helpers/i18n';
import { IllustrationLogoG } from '@grpn/mx-components';

import { IconSocialFacebook } from '@grpn/mx-components';
import { IconSocialLinkedin } from '@grpn/mx-components';
import { IconSocialTwitter } from '@grpn/mx-components';

const renderINTLVersion = (): JSX.Element => {
  const translate = getTranslator('_success._inbound._intl');
  return (
    <div className={classNames('mx-main', styles.container)}>
      <h2>{translate('title')}</h2>
      <p>{translate('subtitle')}</p>
      <div className={styles.separator} />
      <h2>{translate('footnote')}</h2>
      <div className={styles.topIconContainer}>
        <IllustrationLogoG height={50} widht={50} />
      </div>
      <br />
      <p>
        <a className={styles.blogLink} href="/merchant/blog">
          {translate('blog')}
        </a>
        {translate('info')}
      </p>
    </div>
  );
};

const renderSocialLinks = (): JSX.Element => {
  const translate = getTranslator('_success._inbound._us');
  return (
    <div className="row">
      <div className={classNames('md-column', styles.socialItem)}>
        <IconSocialFacebook color="light-gray" size={64} />
        <p>
          {translate('facebook.text')}
          <a
            className={styles.socialLink}
            href="https://www.facebook.com/GrouponWorks"
            target="_blank"
          >
            {translate('facebook.link')}
          </a>
        </p>
      </div>
      <div className={classNames('md-column', styles.socialItem)}>
        <IconSocialLinkedin color="light-gray" size={64} />
        <p>
          {translate('linkedin.text')}
          <a
            className={styles.socialLink}
            href="https://www.linkedin.com/company/18259295/"
            target="_blank"
          >
            {translate('linkedin.link')}
          </a>
        </p>
      </div>
      <div className={classNames('md-column', styles.socialItem)}>
        <IconSocialTwitter color="light-gray" size={64} />
        <p>
          {translate('twitter.text')}
          <a
            className={styles.socialLink}
            href="https://twitter.com/grouponmerchant"
            target="_blank"
          >
            {translate('twitter.link')}
          </a>
        </p>
      </div>
    </div>
  );
};

const renderUSVersion = (): JSX.Element => {
  const translate = getTranslator('_success._inbound._us');
  return (
    <div className={classNames('mx-main', styles.container)}>
      <h1>{translate('title')}</h1>
      <p>{translate('subtitle')}</p>
      <br />
      <h2>{translate('footnote')}</h2>
      <div className={styles.topIconContainer}>
        <IllustrationLogoG height={50} widht={50} />
      </div>
      <br />
      <p>
        <a className={styles.blogLink} href="/merchant/blog">
          {translate('blog')}
        </a>
        {translate('info')}
      </p>
      {renderSocialLinks()}
    </div>
  );
};

const Success: SFC = () => (I18n.country === 'US' ? renderUSVersion() : renderINTLVersion());

export default Success;
